module.exports = __webpack_public_path__ + "media/sharing_sound.0693ca44.mp3";